import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Prices from "../components/Prices";

const ServicePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Price' />

        {/* GalleryLayer */}
        <Prices />
      </MasterLayout>
    </>
  );
};

export default ServicePage;
